import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import localStore from 'store';
import { isEmpty } from 'lodash';
import {
  Message,
  Image,
  Button,
  Label,
  Loader,
  Dimmer,
} from 'semantic-ui-react';
import withPagination from './WithPagination';
import LoadingDataEnhancer from './LoadingData';
import doc from '../assets/doc.png';

import ReactDropzone from '../components/ReactDropzone';

import BulkDealerActionsList from '../views/BulkDealerActions/List';
import bulkDealerActionsQuery from '../graphql/bulkDealerActionsQuery';
import { setPage } from '../data/page/actions';

const BulkDealerActions = props => {
  const {
    data: { bulkDealerActions, refetch },
    setPage: setPageAction,
  } = props;

  const [selectedFile, setSelectedFile] = useState(null);
  const [flashMessage, setFlashMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const onDrop = useCallback(files => {
    setSelectedFile({ name: files[0].name, file: files[0] });
  }, []);

  const uploadImage = useCallback(file => {
    const formData = new FormData();
    const token = localStore.get('jwt');

    formData.append('file', file);
    formData.append('model', 'BulkDealerAction');
    formData.append('AUTHORIZATION', token ? `${token}` : null);

    axios
      .post(process.env.REACT_APP_UPLOAD_API_URL, formData)
      .then(() => {
        setFlashMessage('Successfully Uploaded file and queued for processing');
        setSelectedFile(null);
        setLoading(false);
        refetch();
        setPageAction({});
      })
      .catch(() => {
        setLoading(false);
      });
  }, [refetch, setPageAction]);

  const saveFile = useCallback(() => {
    setLoading(true);
    setFlashMessage('');
    if (!isEmpty(selectedFile)) {
      uploadImage(selectedFile.file);
    } else {
      setLoading(false);
    }
  }, [selectedFile, uploadImage]);

  const handleDismiss = useCallback(() => {
    setFlashMessage(null);
  }, []);

  const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 2,
    marginRight: 2,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box',
  };

  const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
  };

  const img = {
    display: 'block',
    width: 'auto',
    height: '100%',
  };

  return (
    <div className='drop-zone'>
      {flashMessage && (
        <Message
          onDismiss={handleDismiss}
          content={flashMessage}
          positive
        />
      )}
      <ReactDropzone
        accept='.csv'
        onDrop={onDrop}
        multiple={false}
        className='react-drop-zone react-drop-zone-small'
      >
        Drop Dealer Actions Document (CSV File) here!!
      </ReactDropzone>

      <Button color='green' onClick={saveFile} inverted>
        {' '}
        Save
      </Button>
      <br />
      {selectedFile && (
        <Label>
          <div style={thumb}>
            <div style={thumbInner}>
              <Image src={doc} style={img} />
            </div>
          </div>
          <br />
          {selectedFile.name}
        </Label>
      )}
      {loading && (
        <Dimmer active inverted>
          <Loader size='large'>Loading</Loader>
        </Dimmer>
      )}
      <br />
      <br />
      <BulkDealerActionsList allFiles={bulkDealerActions} />
    </div>
  );
};

BulkDealerActions.propTypes = {
  data: PropTypes.shape({
    bulkDealerActions: PropTypes.array,
    refetch: PropTypes.func,
  }).isRequired,
  setPage: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  setPage: () => {
    dispatch(setPage());
  },
});

export default compose(
  withRouter,
  withPagination(bulkDealerActionsQuery, 'bulkDealerActions'),
  LoadingDataEnhancer,
  connect(null, mapDispatchToProps)
)(BulkDealerActions);
